module.exports = __webpack_public_path__ + "img/man.c49d881b.png";